/**
 * @author Fernando Ruano
 * @file constants.js
 * @description Auth Constants
 */

// Generic actions
export const LOG_IN = 'Auth/LOG_IN';
export const RESET_PASSWORD = 'Auth/RESET_PASSWORD';
export const RESET_PASSWORD_REGISTER = 'Auth/RESET_PASSWORD_REGISTER';
export const ACTIVATE_PATIENT_BY_REGISTER = 'Auth/ACTIVATE_PATIENT_BY_REGISTER';
export const RECOVER_PASSWORD = 'Auth/RECOVER_PASSWORD';
export const VERIFY_AUTH = 'Auth/VERIFY_AUTH';
export const SIGN_OUT = 'Auth/SIGN_OUT';
export const GET_CLAIMS = 'Auth/GET_CLAIMS';
export const GET_USER_LIST = 'Auth/GET_USER_LIST';
export const SEND_CODE = 'Auth/SEND_CODE';
export const VERIFY_CODE = 'Auth/VERIFY_CODE';
export const GET_TOKEN = 'Auth/GET_TOKEN';
export const AUTO_ENROLL_FACTOR = 'Auth/AUTO_ENROLL_FACTOR';
